export const elementBorderMixin = {
  props: {
    __elementborderclass: String
  }
};
